"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactCard = require("./ContactCard");
Object.keys(_ContactCard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactCard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactCard[key];
    }
  });
});